<template>
  <div>
    <b-form>
      <b-form-group label="Percent" label-class="control-label workload-course-label"
        :class="{ 'invalid-group': $v.form.percent.$error }">
        <b-form-input v-model="form.percent" placeholder="Enter numbers only"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.form.percent.$error">You must enter a percent
          greater than 0 and less than your remaining
          affiliate work percent ({{ this.percentLimit }}%).</span>
      </b-form-group>

      <b-form-group label="Notes" label-class="control-label workload-course-label">
        <b-form-textarea :rows="3" placeholder="Enter Notes" v-model="form.notes"></b-form-textarea>
        <span v-if="$v.form.notes.$error" class="span-feedback invalid-feedback">
          Please enter a description of your affiliate work duties.
        </span>
      </b-form-group>

      <b-form-file id="affiliate-file-input" class="input-group ml-2" placeholder="Choose File" v-model="file">
      </b-form-file>

    </b-form>
  </div>
</template>

<script>
import { required, decimal, between } from "vuelidate/lib/validators"
import roleChecks from "../../misc/role-checks"

export default {
  mixins: [roleChecks],

  data() {
    return {
      form: {
        id: 0,
        workloadId: 0,
        notes: null,
        percent: 0.0
      },
      file: null,

      basePercent: 0,
      baseUsedPercent: 0
    }
  },

  props: {
    value: {
      type: Boolean,
      required: false
    },
    affiliateWorkRequest: {
      type: Object,
      required: false
    },
    totalPercent: {
      type: Number,
      required: false,
      default: function () {
        return 0
      }
    },
    usedPercent: {
      type: Number,
      required: false,
      default: function () {
        return 0
      }
    }
  },

  computed: {
    percentLimit: function () {
      if (this.affiliateWorkRequest) {
        return this.basePercent + (this.totalPercent - this.baseUsedPercent)
      }
      return this.totalPercent - this.usedPercent
    }
  },

  watch: {
    value: function () {
      if (this.value) {
        this.$v.form.$touch()
        if (!this.$v.form.$error) {
          this.$emit("complete", { form: this.form, file: this.file })
          this.$v.$reset()
          this.form = {
            id: 0,
            workloadId: 0,
            notes: null,
            percent: 0.0
          }
        } else {
          this.$emit("input", false)
        }
      }
    },

    editingAffiliateWorkRequest: function () {
      if (this.editingAffiliateWorkRequest) {
        this.setForm(this.editingAffiliateWorkRequest)
      }
    },

    affiliateWorkRequest: function () {
      if (this.affiliateWorkRequest) {
        this.setForm(this.affiliateWorkRequest)
      }
    }
  },

  validations() {
    return {
      form: {
        notes: {},
        percent: {
          required,
          decimal,
          between: between(0.01, this.percentLimit)
        }
      }
    }
  },

  methods: {
    setForm: function (affiliateWorkRequest) {
      // set values
      this.form = affiliateWorkRequest
      if (!this.form.percent) {
        this.form.percent = this.percentLimit
      }
    }
  },

  created() {
    if (this.affiliateWorkRequest) {
      this.setForm(this.affiliateWorkRequest)
      this.basePercent = this.affiliateWorkRequest.percent
      this.baseUsedPercent = this.usedPercent
    } else {
      this.setForm(this.form)
    }
  }
}
</script>

<style scoped></style>
